<div class="card">
    <div class="card-header bg-card-header bg-opacity-25 d-flex justify-content-between align-items-center">
                 <span class="fw-bold">
                <i class="fas fa-chevron-down me-1"></i>
                     {{ groupName }}
                </span>
        <span class="badge rounded-pill bg-secondary">{{ mapItems.length }}</span>
    </div>
    <div class="card-body p-0 scrollable-container custom-scroll-style">
        <div
                cdkDropList
                #group="cdkDropList"
                [cdkDropListData]="mapItems"
                [cdkDropListConnectedTo]="connectedLists"
                id="mapped-group"
                class="drag-container"
                (cdkDropListDropped)="drop($event)">
            <div class="list-group list-group-flush">
                <div
                        *ngFor="let item of mapItems"
                        cdkDrag
                        class="list-group-item p-2">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold mb-1">{{ item.name }} <i
                                    class="fas fa-arrow-right m-2"></i> {{ item.variable?.name }}
                                @if (item.required) {
                                    <span class="text-danger">({{ 'study-editor.import-design.import-file.mapping.required' | translate}})</span>
                                }
                            </div>
                            <div class="row text-muted small">
                                <div class="col-md-4">
                                    <strong>{{ 'ontology.variable-details.details.property' | translate }}</strong> {{ item?.variable?.property }}
                                </div>
                                <div class="col-md-4">
                                    <strong>{{ 'ontology.variable-details.details.scale' | translate }}</strong> {{ item?.variable?.scale }}
                                </div>
                                <div class="col-md-4">
                                    <strong>{{ 'ontology.variable-details.details.method' | translate }}</strong> {{ item?.variable?.method }}
                                </div>
                            </div>
                        </div>
                        @if (item.variable) {
                            <button class="btn btn-sm btn-info" (click)="onRemapItem(item)">
                                <i class="fas fa-link me-1"></i><span
                                    translate="study-editor.study-dataset.import-study-map.re-map"></span>
                            </button>
                        } @else {
                            <button class="btn btn-sm btn-info" (click)="onRemapItem(item)">
                                <i class="fas fa-pencil-alt me-1"></i><span
                                    translate="study-editor.study-dataset.import-study-map.apply-mapping"></span>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
